import { RouteObject } from "react-router-dom";
import { TasksList } from "../pages/admin/tasks/TasksList";
import { TaskDetail } from "../pages/admin/tasks/TaskDetail";
import { TaskCreate } from "../pages/admin/tasks/TaskCreate";
import { TaskEdit } from "../pages/admin/tasks/TaskEdit";

export const tasksRoutes: RouteObject[] = [
  {
    id: "tasks-list",
    index: true,
    element: <TasksList />,
  },
  {
    id: "task-detail",
    path: ":id",
    element: <TaskDetail />,
  },
  {
    id: "task-create",
    path: "create",
    element: <TaskCreate />,
  },
  {
    id: "task-edit",
    path: ":id/edit",
    element: <TaskEdit />,
  },
];
